import { formatTimeOfDay } from "@sp-crm/core";

export interface TimeOption {
    value: string;
    label: string;
}

const startMinutes = 6 * 60;
const endMinutes = 22 * 60 + 45;
const stepMinutes = 15;

export const DEFAULT_TIME_LIST_ANCHOR = "09:00";

const parseMinutes = (value: string): number | null => {
    const match = /^(\d{2}):(\d{2})$/.exec(value);
    if (!match) {
        return null;
    }
    const hours = Number(match[1]);
    const minutes = Number(match[2]);
    if (hours > 23 || minutes > 59) {
        return null;
    }
    return hours * 60 + minutes;
};

const toHhmm = (minutes: number): string => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
};

export const normalizeTimeValue = (value: string | null): string | null => {
    if (!value) {
        return null;
    }
    const match = /^(\d{2}):(\d{2})/.exec(value);
    return match ? `${match[1]}:${match[2]}` : value;
};

const baseOptions = (): TimeOption[] => {
    const options: TimeOption[] = [];
    for (let minutes = startMinutes; minutes <= endMinutes; minutes += stepMinutes) {
        const value = toHhmm(minutes);
        options.push({ value, label: formatTimeOfDay(value) });
    }
    return options;
};

export const buildTimeOptions = (value: string | null): TimeOption[] => {
    const options = baseOptions();
    if (!value) {
        return options;
    }
    const minutes = parseMinutes(value);
    if (minutes === null || options.some(option => option.value === value)) {
        return options;
    }
    return [...options, { value, label: formatTimeOfDay(value) }].sort(
        (a, b) => (parseMinutes(a.value) ?? 0) - (parseMinutes(b.value) ?? 0),
    );
};
